export enum Features {
  OpenLogFolder = 'OpenLogFolder',
  ZoomView = 'ZoomView',
  AudioNotifications = 'AudioNotifications',
  PreCallInfo = 'PreCallInfo',
}
